/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * InsightsOverTimeBinDtoBase
 * auto generated base class for the model InsightsOverTimeBinDtoModel.
 */
export const InsightsOverTimeBinDtoModelBase = ModelBase
  .named('InsightsOverTimeBinDto')
  .props({
    __typename: types.optional(types.literal("InsightsOverTimeBinDto"), "InsightsOverTimeBinDto"),
    interval: types.union(types.undefined, types.string),
    value: types.union(types.undefined, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class InsightsOverTimeBinDtoModelSelector extends QueryBuilder {
  get interval() { return this.__attr(`interval`) }
  get value() { return this.__attr(`value`) }
}
export function selectFromInsightsOverTimeBinDto() {
  return new InsightsOverTimeBinDtoModelSelector()
}

export const insightsOverTimeBinDtoModelPrimitives = selectFromInsightsOverTimeBinDto().interval.value
